import { render, staticRenderFns } from "./AiInsights.vue?vue&type=template&id=af61a412&scoped=true&"
import script from "./AiInsights.vue?vue&type=script&lang=ts&"
export * from "./AiInsights.vue?vue&type=script&lang=ts&"
import style0 from "./AiInsights.vue?vue&type=style&index=0&id=af61a412&lang=scss&scoped=true&"
import style1 from "./AiInsights.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af61a412",
  null
  
)

export default component.exports